module.exports = __webpack_public_path__ + "img/guideline_fee.bf7b6723.jpeg";